module.exports = "ul {\r\n  padding: 0;\r\n  list-style-type: none;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/publishers/top-advertisers/top-advertisers.component.css
// module id = ./src/app/publishers/top-advertisers/top-advertisers.component.css
// module chunks = main